import i18n from 'i18next';
import { FilterFn } from '@tanstack/react-table';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const globalFilterFn: FilterFn<any> = (row, _columnId, filterValue) => {
  const searchTerm = filterValue.toLowerCase();

  // Check combined first_name + last_name for full name search
  const firstName = row.original.first_name as string | undefined;
  const lastName = row.original.last_name as string | undefined;
  if (firstName && lastName) {
    const fullName = `${firstName} ${lastName}`.toLowerCase();
    if (fullName.includes(searchTerm)) {
      return true;
    }
  }

  return Object.entries(row.original).some(([key, value]) => {
    const stringValue = String(value).toLowerCase();

    if (stringValue.includes(searchTerm)) {
      return true;
    }

    // necessary to find status values displayed in German
    if (key === 'status' && typeof value === 'string') {
      const statusOptions = [
        'INACTIVE',
        'ACTIVE',
        'PAUSED',
        'RESIGNED',
        'INVITATION_PENDING_EMAIL',
        'INVITATION_PENDING_PDF',
        'DEACTIVATION_DELAYED'
      ];

      return statusOptions.some((status) => {
        if (value === status) {
          const translation = i18n.t(`employee:${status}`).toLowerCase();
          return translation.includes(searchTerm);
        }
        return false;
      });
    }

    if (key === 'next_month_benefit_set' && value && typeof value === 'object') {
      const benefitSet = value as { name?: string };
      const benefitSetName = benefitSet.name?.toLowerCase() ?? '';
      return benefitSetName.includes(searchTerm);
    }

    if (key === 'member_groups' && Array.isArray(value)) {
      const groups = value as Array<{ name?: string }>;
      return groups.some((group) => group.name?.toLowerCase().includes(searchTerm));
    }

    if (key === 'custom') {
      const isCustom = Boolean(value);
      if (isCustom && 'custom'.includes(searchTerm)) {
        return true;
      }
      if (!isCustom && 'pxtra'.includes(searchTerm)) {
        return true;
      }
    }

    return false;
  });
};
